import React from 'react';

import { ArrowButton } from 'components/arrow-button/ArrowButton';

import s from './SectionHeader.scss';

interface IProps {
  heading?: string;
  link?: string;
  linkText?: string;
}

export const SectionHeader = ({ heading, link, linkText }: IProps) => {
  return (
    <header className={s('sectionHeader', { hasLink: link })}>
      {heading && <h2 className={s.sectionHeader__heading}>{heading}</h2>}
      {link && <ArrowButton direction="forward" to={link}> {linkText ?? 'See all articles'}</ArrowButton>}
    </header>
  );
};